import React, { Component } from "react";
import EditIconButton from "../buttons/EditIconButton";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { ValidatorForm } from "react-material-ui-form-validator";
import CancelIconButton from "../buttons/CancelIconButton";
import SaveButton from "../buttons/SaveButton";
import store from "../../../redux/store";
import FetchServerData from "../../../provider/FetchServerData";
import PtsAlert from "../ptsAlert/PtsAlert";
import InfoTooltip from "../infoTooltip/InfoTooltip";
import Utils from "../../../provider/Utils";
class PledgePaymentIntegration extends Component {
  header = store.getState().header.header;
  pledgePaymentIntegrationList =
    store.getState().staticData.pledgePaymentIntegrationList;
  accountSettings = store.getState().accountSetting?.accountSetting;
  constructor(props) {
    super(props);
    this.bottomRef = React.createRef();
    let action = props.action;
    let pledgePaymentIntegration = props.pledgePaymentIntegration;
    let pledgePaypalSettings = props.pledgePaypalSettings;
    let pledgeBlackbaudSettings = props.pledgeBlackbaudSettings;
    let isDonarPaymentConfirmationText = props.isDonarPaymentConfirmationText;
    let donarPaymentConfirmationText = props.donarPaymentConfirmationText;
    this.state = {
      action: action,
      pledgePaymentIntegration: pledgePaymentIntegration,
      pledgePaypalSettings: pledgePaypalSettings,
      paypalId: pledgePaypalSettings?.paypalid,
      pledgeBlackbaudSettings: pledgeBlackbaudSettings,
      blackbaudAppeal: pledgeBlackbaudSettings?.appeal,
      blackbaudCampaign: pledgeBlackbaudSettings?.campaing,
      blackbaudFund: pledgeBlackbaudSettings?.fund,
      blackbaudPackage: pledgeBlackbaudSettings?.package,
      paypalIntegrationShow: pledgePaypalSettings !== null ? true : false,
      blackbaudIntegrationShow: pledgeBlackbaudSettings !== null ? true : false,
      render: false,
      donarPaymentConfirmationText: donarPaymentConfirmationText,
      isDonarPaymentConfirmationText: isDonarPaymentConfirmationText,
      confirmationText: isDonarPaymentConfirmationText ? { name: "Send a text confirmation", isDonarPaymentConfirmationText: true, id: 1 } : { name: "Do not send a text confirmation", isDonarPaymentConfirmationText: false, id: 2 },
    };
  }

  scrollToBottom = () => {
    this.bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  editPaymentIntegrationDetails() {
    this.scrollToBottom();
    this.setState({
      action: "edit",
      pledgePaypalSettings: this.state.pledgePaypalSettings,
      paypalId: this.state.paypalId,
    });
  }

  handlePledgePaymentIntegrationChange(selectedValue) {
    if (selectedValue.name === "Paypal") {
      this.setState({
        pledgePaymentIntegration: selectedValue,
        paypalIntegrationShow: true,
        blackbaudIntegrationShow: false,
        isDonarPaymentConfirmationText: false,
        confirmationText: { name: "Do not send a text confirmation", isDonarPaymentConfirmationText: false, id: 2 },

      });
    } else if (selectedValue.name === "Blackbaud") {
      this.setState({
        pledgePaymentIntegration: selectedValue,
        paypalid: "",
        paypalIntegrationShow: false,
        blackbaudIntegrationShow: true,
        isDonarPaymentConfirmationText: false,
        confirmationText: { name: "Do not send a text confirmation", isDonarPaymentConfirmationText: false, id: 2 },
      });
    } else {
      this.setState({
        pledgePaymentIntegration: selectedValue,
        paypalid: "",
        paypalIntegrationShow: false,
        blackbaudIntegrationShow: false,
        isDonarPaymentConfirmationText: false,
        confirmationText: { name: "Do not send a text confirmation", isDonarPaymentConfirmationText: false, id: 2 }
      });
    }
  }
  handlePaymentPayPalIdChange(e) {
    this.setState({
      paypalId: e.target.value,
    });
  }

  handleBlackbaudAppealChange(selectedValue) {
    this.getAppealPackages(selectedValue);
    this.setState({
      blackbaudAppeal: selectedValue,
    });
  }
  handleBlackbaudPackageChange(selectedValue) {
    this.setState({
      blackbaudPackage: selectedValue,
    });
  }
  handleBlackbaudCampaignChange(selectedValue) {
    this.setState({
      blackbaudCampaign: selectedValue,
    });
  }
  handleBlackbaudFundChange(selectedValue) {
    this.setState({
      blackbaudFund: selectedValue,
    });
  }

  updatePledgePaymentIntegrationToBackend() {
    const postObject = {
      header: this.header,
      pledgePaymentIntegration: this.state.pledgePaymentIntegration,
      pledgePaypalSettings: {
        paypalid: this.state.paypalId,
      },
      pledgeBlakbaudSettings: null,
      isDonarPaymentConfirmationText: this.state.isDonarPaymentConfirmationText,
      donarPaymentConfirmationText: this.state.isDonarPaymentConfirmationText
        ? this.state.donarPaymentConfirmationText
        : "",
    };
    FetchServerData.callPostService(
      "/integrationms/updatePledgePayment",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        // PtsAlert.success(output.message);
        let crmIntegrationDetails = output.data;
        this.setState({
          action: "view",
          pledgePaymentIntegration:
            crmIntegrationDetails.pledgePaymentIntegration,
          pledgePaypalSettings: crmIntegrationDetails.pledgePaypalSettings,
          pledgeBlackbaudSettings:
            crmIntegrationDetails.pledgeBlackbaudSettings,
        });
      } else {
      }
    });
  }

  onClickCancel() {
    this.setState({
      action: "view",
      pledgePaymentIntegration: this.props.pledgePaymentIntegration,
      pledgePaypalSettings: this.props.pledgePaypalSettings,
      paypalId: this.props.pledgePaypalSettings?.paypalid,
      pledgeBlackbaudSettings: this.props.pledgeBlackbaudSettings,
      blackbaudAppeal: this.props.pledgeBlackbaudSettings?.appeal,
      blackbaudCampaign: this.props.pledgeBlackbaudSettings?.campaing,
      blackbaudFund: this.props.pledgeBlackbaudSettings?.fund,
      blackbaudPackage: this.props.pledgeBlackbaudSettings?.package,
      isDonarPaymentConfirmationText: this.props.isDonarPaymentConfirmationText,
      donarPaymentConfirmationText: this.props.donarPaymentConfirmationText,
      confirmationText: this.props.isDonarPaymentConfirmationText ? { name: "Send a text confirmation", isDonarPaymentConfirmationText: true, id: 1 } : { name: "Do not send a text confirmation", isDonarPaymentConfirmationText: false, id: 2 },
    });
  }

  blackBaudIntegration() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService("/bbPaymentms/getAuthURL", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          window.open(
            output.data,
            "login",
            "width=600,height=500,screenX=500,screenY=80"
          );
          this.setState({ action: "view" });
        } else {
        }
      }
    );
  }

  handleOpen() {
    this.setState({ openBlackbaud: true });
  }

  handleClose() {
    this.setState({ openBlackbaud: false });
  }

  helpContentsDialogBox() {
    return (
      <Dialog
        open={this.state.openBlackbaud}
        onClose={this.handleClose.bind(this)}
        maxWidth="xl"
        className="QRCodeDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>
            How to connect GivBee to your Blackbaud account
          </span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent>
          <div
            className="row d-flex"
            style={{
              width: "100%",
              color: "#000",
              fontSize: "small",
              padding: "0.5em",
            }}
          >
            <p>
              <span className="fw-bold fs-6">
                Part I: BBMS Connection Setup
              </span>
              <p className="mb-0">
                Do you want to be able to accept payments through GivBee's
                direct integration with Blackbaud Merchant Services?
              </p>
              <p>
                Only Blackbaud users with certain security roles can make the
                BBMS connection work. This must be done before Part II below.
              </p>
              <p> To confirm you have the proper role, follow these steps:</p>
              <ol className="m-1">
                <li>
                  Log in to your Blackbaud Admin account and choose Security
                  from the top menu bar.
                </li>
                <li>Go to Roles Management.</li>
                <li>
                  Verify that you have a Payments API Roles tile showing, with
                  at least one role defined such as a "Payments API User" role.
                </li>
                <li>
                  If the role or tile is missing, you must first add it to your
                  account. Instructions
                  <a
                    className="anchortag ms-1"
                    target="blank"
                    href="https://kb.blackbaud.com/knowledgebase/Article/191009"
                  >
                    https://kb.blackbaud.com/knowledgebase/Article/191009
                  </a>
                </li>
              </ol>
            </p>
          </div>
        </DialogContent>
        <DialogActions
          style={{
            // marginTop: "1em",
            padding: "1em",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <Button
            variant="contained"
            size="small"
            style={{
              background: "#224f77",
              color: "#fff",
            }}
            onClick={this.handleClose.bind(this)}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  handleIsDonarPaymentConfirmationTextChange = (e) => {
    this.setState({
      isDonarPaymentConfirmationText: e.target.value === "true",
    });
  };

  handleConfirmationTextChange(selectedValue) {
    this.setState({
      confirmationText: selectedValue,
      isDonarPaymentConfirmationText: selectedValue?.isDonarPaymentConfirmationText,
    });
  }

  handleDonarPaymentConfirmationTextChange(e) {
    this.setState({
      donarPaymentConfirmationText: e.target.value,
    });
  }

  render() {
    if (this.state.action === "view") {
      return this.viewPaymentIntegration();
    } else {
      return this.editPaymentIntegration();
    }
  }
  viewPaymentIntegration() {
    return (
      <div className="row mt-4">
        <div className="col-md-12">
          <div className="card" id="giveBeeCard" style={{ height: "345px" }}>
            <div
              className="card-header d-flex align-items-center justify-content-between p-2"
              id="assetCardHeader"
            >
              <div className="col-md-6 align-self-center">
                <h6
                  className="mb-0"
                  id="headerLabel"
                  style={{ fontWeight: "600", color: "#353538" }}
                >
                  Integrated Payment Services
                </h6>
              </div>
              <div
                className="col-md-6 text-end"
                ref={this.bottomRef}
                style={{
                  // borderRight: "1px solid #eceaea",
                  // background: "#ececec",
                  color: "#000",
                  fontWeight: "bold",
                  padding: "0.5em",
                  textAlign: "right",
                }}
              >
                <EditIconButton
                  onClick={this.editPaymentIntegrationDetails.bind(this)}
                />
              </div>
            </div>
            <div className="card-body pb-0">
              <div
                className="row justify-content-start"
                style={{ height: "120px" }}
              >
                <div className="col-md-3"> </div>
                <div className="col-md-8">
                  <div className="row" style={{ height: "37.55px" }}>
                    <label
                      className="col-sm-3 col-form-label fw-bold align-self-center"
                      htmlFor="basic-default-name"
                      id="assetFormLabel"
                    >
                      Payment Type
                    </label>
                    <div className="col-sm-9" id="givbeeText">
                      <span className="me-4">
                        {this.state.pledgePaymentIntegration?.description}
                      </span>
                      {this.state.pledgePaymentIntegration?.name ===
                        "Blackbaud" && (
                          <>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.handleOpen();
                              }}
                              className="anchortag"
                            >
                              <u>How to connect</u>
                            </a>
                            {!this.state.pledgeBlackbaudSettings?.isConnected && (
                              <span className="ms-4">
                                <Button
                                  className="givbeeButton"
                                  style={{
                                    color: "white",
                                    width: "80px",
                                    height: "28px",
                                    fontWeight: "600",
                                    fontSize: "x-larger",
                                    textTransform: "capitalize",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => this.blackBaudIntegration()}
                                >
                                  Connect
                                </Button>
                              </span>
                            )}
                          </>
                        )}
                    </div>
                  </div>
                  {this.state.pledgePaymentIntegration?.name ===
                    "Blackbaud" && (
                      <div className="row mt-2">
                        {this.state.pledgeBlackbaudSettings?.isConnected && (
                          <>
                            <label
                              className="col-sm-3 col-form-label fw-bold align-self-center"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Status
                            </label>
                            <div className="col-md-9" id="givbeeText">
                              <span>Connected</span>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  {this.state.pledgePaypalSettings !== null && (
                    <div className="row mt-2">
                      <label
                        className="col-sm-3 col-form-label fw-bold align-self-center"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Paypal ID
                      </label>
                      <div className="col-sm-9" id="givbeeText">
                        <span>{this.state.pledgePaypalSettings?.paypalid}</span>
                      </div>
                    </div>
                  )}
                  {this.state.pledgePaymentIntegration?.name !== "None" && (
                    <div className="row mt-2">
                      <label
                        className="col-sm-3 col-form-label fw-bold align-self-center"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        When credit card payments are processed
                      </label>
                      <div className="col-sm-9" id="givbeeText">
                        {this.state.confirmationText?.name}
                      </div>
                    </div>
                  )}
                  {this.state.isDonarPaymentConfirmationText && (
                    <div className="row mt-2">
                      <label
                        className="col-sm-3 col-form-label fw-bold align-self-center"
                        htmlFor="basic-default-name"
                        id="assetFormLabel"
                      >
                        Confirmation Text
                      </label>
                      <div className="col-sm-9" id="givbeeText">
                        {this.state.donarPaymentConfirmationText}
                      </div>
                    </div>
                  )}
                </div>
                {this.helpContentsDialogBox()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  editPaymentIntegration() {
    return (
      <div className="row mt-4">
        <div className="col-md-12">
          <div className="card" id="giveBeeCard" style={{ height: "370px" }}>
            <div
              className="card-header d-flex align-items-center justify-content-between p-2"
              id="assetCardHeader"
            >
              <div className="col-md-6 align-self-center">
                <h6
                  className="mb-0"
                  id="headerLabel"
                  style={{ fontWeight: "600", color: "#353538" }}
                >
                  Integrated Payment Services
                </h6>
              </div>
              <div
                className="col-md-6 text-end"
                style={{
                  color: "#000",
                  fontWeight: "bold",
                  padding: "0.5em",
                  textAlign: "right",
                  height: "42px",
                }}
              ></div>
            </div>
            <div className="card-body pb-0">
              <ValidatorForm
                ref="form"
                id="multiStepsForm"
                onSubmit={this.updatePledgePaymentIntegrationToBackend.bind(
                  this
                )}
              >
                <div className="row d-flex" style={{ height: "230px" }}>
                  <div className="col-md-3"> </div>
                  <div className="col-md-8">
                    <div className="row" >
                      <label
                        htmlFor="exampleFormControlTextarea1"
                        className="col-sm-3 col-form-label fw-bold align-self-center"
                      >
                        Payment Type
                      </label>
                      <div className="col-sm-5 m-0" id="givbeeText">
                        <Autocomplete
                          id="size-small-outlined"
                          size="small"
                          fullWidth
                          disableClearable
                          ListboxProps={{
                            className: "custom-listbox",
                          }}
                          options={this.pledgePaymentIntegrationList}
                          value={this.state.pledgePaymentIntegration}
                          getOptionLabel={(option) => option.description}
                          defaultValue={this.state.crmIntegration}
                          onChange={(event, value) => {
                            this.handlePledgePaymentIntegrationChange(value);
                          }}
                          inputprops={{
                            style: {
                              textTransform: "capitalize",
                            },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Please Select"
                              variant="outlined"
                              size="small"
                              className="textField"
                              style={{ background: "#fff" }}
                            />
                          )}
                        />
                      </div>
                    </div>
                    {this.state.paypalIntegrationShow && (
                      <div className="row mt-3">
                        <label
                          className="col-sm-3 col-form-label fw-bold  align-self-center"
                          htmlFor="multiStepsState"
                        >
                          PayPal ID
                        </label>
                        <div className="col-sm-5 m-0" id="givbeeText">
                          <input
                            required
                            type="text"
                            autoComplete="off"
                            id="multiStepsName"
                            className="form-control"
                            name="multiStepsName"
                            value={this.state.paypalId}
                            onChange={this.handlePaymentPayPalIdChange.bind(
                              this
                            )}
                          />
                        </div>
                      </div>
                    )}
                    {this.state.pledgePaymentIntegration?.name !== "None" && (
                      <div className="row mt-2">
                        <label
                          htmlFor="exampleFormControlTextarea1"
                          className="col-sm-3 col-form-label fw-bold  align-self-center"
                        >
                          When credit card payments are processed
                          <span className="one-line-tooltip">
                            <InfoTooltip
                              data="Does not work for Venmo, Apple Pay, Google Pay, etc."
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    whiteSpace: "nowrap",
                                    maxWidth: "none",
                                  },
                                },
                              }}
                            />
                          </span>
                        </label>
                        <div
                          className="col-sm-5 m-0 align-self-center"
                          id="givbeeText"
                        >
                          {/* <span className="custom-radio">
                            <input
                              type="radio"
                              id="yes"
                              name="blackbaudActivity"
                              value="true"
                              checked={
                                this.state.isDonarPaymentConfirmationText ===
                                true
                              }
                              onChange={
                                this.handleIsDonarPaymentConfirmationTextChange
                              }
                            />
                            <label
                              className="col-form-label ps-1"
                              htmlFor="yes"
                            >
                              ON
                            </label>
                          </span>
                          <span className="ms-3 custom-radio">
                            <input
                              type="radio"
                              id="no"
                              name="blackbaudActivity"
                              value="false"
                              checked={
                                this.state.isDonarPaymentConfirmationText ===
                                false
                              }
                              onChange={
                                this.handleIsDonarPaymentConfirmationTextChange
                              }
                            />
                            <label className="col-form-label ps-1" htmlFor="no">
                              OFF
                            </label>
                          </span> */}
                          <Autocomplete
                            id="size-small-outlined"
                            size="small"
                            fullWidth
                            disableClearable
                            ListboxProps={{
                              className: "custom-listbox",
                            }}
                            options={[{ name: "Send a text confirmation", isDonarPaymentConfirmationText: true, id: 1 }, { name: "Do not send a text confirmation", isDonarPaymentConfirmationText: false, id: 2 }]}
                            value={this.state.confirmationText}
                            getOptionLabel={(option) => option.name}
                            defaultValue={this.state.confirmationText}
                            onChange={(event, value) => {
                              this.handleConfirmationTextChange(value);
                            }}
                            inputprops={{
                              style: {
                                textTransform: "capitalize",
                              },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Please Select"
                                variant="outlined"
                                size="small"
                                className="textField"
                                style={{ background: "#fff" }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    )}
                    {this.state.isDonarPaymentConfirmationText && (
                      <div className="row mt-2">
                        <label
                          htmlFor="exampleFormControlTextarea1"
                          className="col-sm-3 col-form-label fw-bold  align-self-center"
                        >
                          Confirmation Text
                        </label>
                        <div className="col-sm-5 m-0" id="givbeeText">
                          <textarea
                            title=""
                            type="text"
                            autoComplete="off"
                            required
                            className="form-control"
                            id="messageBox"
                            rows="2"
                            aria-describedby="multiStepsCardImg"
                            value={this.state.donarPaymentConfirmationText}
                            onChange={this.handleDonarPaymentConfirmationTextChange.bind(
                              this
                            )}
                          />
                          <span
                            style={{
                              fontSize: "14px",
                              float: "right",
                            }}
                          >
                            {Utils.trimLetters(this.state.donarPaymentConfirmationText) || 0}/
                            {this.accountSettings?.textMessageLength}
                          </span>
                          {this.accountSettings?.textMessageLength <
                            Utils.countLetters(this.state.donarPaymentConfirmationText) && (
                              <>
                                <br></br>
                                <span
                                  className="danger ms-1"
                                  style={{ color: "red", fontSize: "14px" }}
                                >
                                  Your message is limited to{" "}
                                  {this.accountSettings?.textMessageLength}{" "}
                                  characters.
                                </span>
                              </>
                            )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="row d-flex align-items-center justify-content-between">
                  <div className="col-sm-12 mt-4 text-center">
                    <SaveButton id="saveButton" type="submit">
                      Save
                    </SaveButton>
                    &nbsp;&nbsp;
                    <CancelIconButton onClick={(e) => this.onClickCancel()} />
                  </div>
                </div>
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default PledgePaymentIntegration;
